import { DomSanitizer } from '@angular/platform-browser';
import { SistemaDTO } from './../_classes/sistema-dto';
import { Filtro } from './../_classes/filtro';
import { Util } from './../_classes/util';
import { ModalAlertaService } from './../shared/modal-alerta.service';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, take, tap } from 'rxjs/operators';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { MatAccordion } from '@angular/material/expansion';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { Servidor } from '../_classes/servidor';

@Component({
  selector: 'app-sistemas',
  templateUrl: './sistemas.component.html',
  styleUrls: ['./sistemas.component.scss'],
})
export class SistemasComponent implements OnInit {
  private readonly recurso: string = 'sistemas'; //mesmo que a rota

  @ViewChild(MatAccordion) accordion: MatAccordion;

  carregando = false;
  panelOpenState = false;

  //servidor$: Observable<Servidor>;
  servidorTmp: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<SistemaDTO[]>;
  dataSource: MatTableDataSource<SistemaDTO>;

  soAtivo: boolean = false;
  todos: boolean = true;

  itensAjuda = [];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private sanitizer: DomSanitizer,
    private env: EnvService
  ) {
    //console.log('constructor');
  }

  ngOnInit() {
    //console.log('onInit()');
    this.atualizar();
  }

  mostrarFoto(foto: Blob) {
    const blob = new Blob([Util.Base64ToBlob(foto)], {
      type: 'image/bmp',
    });
    let arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    return arquivoUrl;
  }

  executarAoCarregarDatasource(x: SistemaDTO[]) {
    this.dataSource = new MatTableDataSource<SistemaDTO>(x);
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    this.servidorTmp = new Servidor(this.env.servidor);
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
  }

  buscarNovo() {
    //console.log('todos', this.todos);
    //console.log('soAtivo', this.soAtivo);
    this.panelOpenState = false;
    let f = new Filtro();
    f.chave = this.todos ? '-' : 'ativo';
    f.id = this.soAtivo ? 'S' : 'N';
    let x: Filtro[] = [];
    x.push(f);

    this.dataSource$ = this.service.listarComFiltro(x, 'sistemas').pipe(
      //this.service.listarSistema().pipe(
      tap((a) => this.executarAoCarregarDatasource(a)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );
  }

  buscarOld() {
    this.panelOpenState = false;
    this.dataSource$ = this.service.listarSistema().pipe(
      tap((a) => this.executarAoCarregarDatasource(a)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
